import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedOutgoingServer = mutatorAction('updateAdvancedOutgoingServer', function (smtpServer) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.smtpServer = smtpServer;
});
//# sourceMappingURL=updateAdvancedOutgoingServer.js.map